module.exports = __webpack_public_path__ + "static/media/fashion-item.c1b05909.jpg";